// EsSystem actions
import {modalActions} from "./modal.actions";
import {daliEsSystemService} from "../services/dali-es-system.service";
import {daliEsSystemConstants} from "../constants/dali-es-system.constants";
import {toastr} from 'react-redux-toastr'
import i18next from "i18next";

// region area
const getEsSystemArea = (networkDeviceId) => {
    return dispatch  => {
        daliEsSystemService.getArea(networkDeviceId)
            .then(
                (areaModel) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_AREA_LIST_SUCCESS, areaModel})
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_AREA_LIST_FAILURE, error})
                }
            )
    }
};

const getEsSystemAreaById = (areaId) => {
    return dispatch => {
        daliEsSystemService.getAreaById(areaId)
            .then(
                (areaSingleModel) => {
                    dispatch(getGroupFromDevice(areaSingleModel.networkDeviceId));
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_AREA_ITEM_SUCCESS, areaSingleModel})
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_AREA_ITEM_FAILURE, error})
                }
            );
    }
};

const createEsSystemArea = (areaModel) => {
    return dispatch => {
        daliEsSystemService.createArea(areaModel)
            .then(
                (res) => {
                    dispatch(getEsSystemArea(res.networkDeviceId));
                    dispatch(modalActions.hideModal())
                },
            )
    }
};

const editEsSystemArea = (areaModel) => {
    return dispatch => {
        daliEsSystemService.editArea(areaModel)
            .then(
                (res) => {
                    dispatch(getEsSystemArea(res.networkDeviceId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log("errorValidation: " + error)
                }
            )
    }
};

const deleteEsSystemArea = (areaId, deviceId) => {
    return dispatch => {
        daliEsSystemService.deleteArea(areaId)
            .then(
                (res) => {
                    dispatch(getEsSystemArea(deviceId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

// region group
const getEsSystemGroups = (networkDeviceId) => {
    return dispatch => {
        daliEsSystemService.getGroups(networkDeviceId)
            .then(
                (groupsModel) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_GROUP_LIST_SUCCESS, groupsModel})
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_GROUP_LIST_FAILURE, error})
                }
            );
    }
};

const createEsSystemGroup = (groupModel) => {
    return dispatch => {
        daliEsSystemService.createGroup(groupModel)
            .then(
                (res) => {
                    dispatch(getEsSystemAreaById(res.daliEsSystemAreaId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const editEsSystemGroup = (groupModel) => {
    return dispatch => {
        daliEsSystemService.editGroup(groupModel)
            .then(
                (res) => {
                    dispatch(getEsSystemAreaById(res.daliEsSystemAreaId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log(error)
                }
            );
    }
};

const deleteEsSystemGroup = (groupId, areaId) => {
    return dispatch => {
        daliEsSystemService.deleteGroup(groupId)
            .then(
                () => {
                    dispatch(getEsSystemAreaById(areaId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const getEsSystemGroupById = (groupId) => {
    return dispatch => {
        daliEsSystemService.getGroupById(groupId)
            .then(
                (groupItem) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_GROUP_ITEM_SUCCESS, groupItem})
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_GROUP_ITEM_FAILURE, error})
                }
            )
    }
};

// region scenes
const getEsSystemScenes = (groupId) => {
    return dispatch => {
        daliEsSystemService.getScenes(groupId)
            .then(
                (scenesModel) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_SCENE_LIST_SUCCESS, scenesModel})
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_SCENE_LIST_FAILURE}, error)
                }
            )
    }
};

const createEsSystemScene = (sceneModel) => {
    return dispatch => {
        daliEsSystemService.createScene(sceneModel)
            .then(
                (sceneModel) => {
                    dispatch(getEsSystemGroupById(sceneModel.daliEsSystemGroupId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_VALIDATION_FORM, error})
                }
        );
    }
};

const editEsSystemScene = (sceneModel) => {
    return dispatch => {
        daliEsSystemService.editScene(sceneModel)
            .then(
                (sceneModel) => {
                    dispatch(getEsSystemGroupById(sceneModel.daliEsSystemGroupId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_VALIDATION_FORM, error})
                }
            );
    }
};

const deleteEsSystemScene = (sceneId, groupId) => {
    return dispatch => {
        daliEsSystemService.deleteScene(sceneId)
            .then(
                () => {
                    dispatch(getEsSystemGroupById(groupId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_SCENE_LIST_FAILURE, error})
                }
            )
    }
};

const getGroupFromDevice = (networkDeviceId) => {
    return dispatch => {
        daliEsSystemService.getGroupsFromDevice(networkDeviceId)
            .then(
                (groups) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_GET_GROUPS_FROM_DEVICE_SUCCESS, groups});
                },
                (error) => {
                    dispatch({type: daliEsSystemConstants.ES_SYSTEM_GET_GROUPS_FROM_DEVICE_FAILURE});
                    toastr.error(i18next.t("error.connection-error"), i18next.t('error.es-system-server-error'))
                }
            )
    }
};

const clearGroupFromDevice = () => {
    return dispatch => {
        dispatch({type: daliEsSystemConstants.ES_SYSTEM_GET_GROUPS_FROM_DEVICE_CLEAR})
    }
};

const clearEsSystemStore = () => {
    return dispatch => {
        dispatch({type: daliEsSystemConstants.ES_SYSTEM_CLEAR})
    }
};

export const daliEsSystemActions = {
    // EsSystem area
    getEsSystemArea,
    getEsSystemAreaById,
    createEsSystemArea,
    editEsSystemArea,
    deleteEsSystemArea,
    // EsSystem group
    getEsSystemGroups,
    createEsSystemGroup,
    editEsSystemGroup,
    deleteEsSystemGroup,
    getEsSystemGroupById,
    // EsSystem scenes
    getEsSystemScenes,
    createEsSystemScene,
    editEsSystemScene,
    deleteEsSystemScene,
    // other
    getGroupFromDevice,
    clearGroupFromDevice,
    clearEsSystemStore
};
